import { getToken } from '@optimus-web/common';
import { BannerVariant } from './types';

export const getBannerBackgroundColor = (variant: BannerVariant) => {
    switch (variant) {
        case 'error':
            return getToken('backgroundAlertDangerDefault');
        case 'info':
            return getToken('backgroundAlertInfoDefault');
        case 'success':
            return getToken('backgroundAlertSuccessDefault');
        case 'warning':
            return getToken('backgroundAlertWarningDefault');
    }
};

export const getBannerColor = (variant: BannerVariant) => {
    switch (variant) {
        case 'error':
            return getToken('textAlertDanger');
        case 'info':
            return getToken('textAlertInfo');
        case 'success':
            return getToken('textAlertSuccess');
        case 'warning':
            return getToken('textAlertWarning');
    }
};
